// This file is expected to be deleted, once campaign-io is fully migrated to the new ADK-based system.
/**
 * Type guard to determine if a given raw event is a legacy ServiceAgentSSEEvent,
 * which is used to differentiate between regular session events and streaming SSE events from the agent.
 */
export function isLegacyServiceAgentSSEEvent(event) {
    return (typeof event === "object" &&
        event !== null &&
        "agent" in event &&
        "created" in event &&
        "partial" in event &&
        typeof event.partial === "boolean" &&
        "turnComplete" in event &&
        typeof event.turnComplete === "boolean");
}
/**
 * Legacy `content`/`thoughts` are plain strings; the canonical event shape represents both as `Part[]`.
 * A thought (if present) is represented as a `Part` with `thought: true`, matching how ADK
 * represents thoughts, so downstream consumers can treat both versions the same way.
 */
function partsFromLegacyText(text, thoughts) {
    const parts = [];
    if (thoughts) {
        parts.push({ thought: true, text: thoughts });
    }
    if (text) {
        parts.push({ text });
    }
    return parts;
}
/** Maps a legacy REST session event to the canonical {@link AgentSessionEvent} shape. */
export function fromLegacyServiceAgentSessionEvent(event) {
    return {
        id: event.id,
        role: event.role,
        author: event.author,
        content: { parts: partsFromLegacyText(event.content, event.thoughts) },
        timestamp: new Date(event.timestamp).getTime(),
        confidence: event.confidence,
        errorMessage: event.error
    };
}
/**
 * Maps a legacy SSE chunk to the canonical {@link AgentSessionEvent} shape, preserving `partial`
 * so callers know whether to append this event's `content` to a prior chunk or treat it as final.
 */
export function fromLegacyServiceAgentSessionSSEEvent(event) {
    return {
        id: event.id,
        role: "model",
        author: event.agent,
        content: { parts: partsFromLegacyText(event.message, event.thoughts) },
        timestamp: new Date(event.created).getTime(),
        confidence: event.confidence,
        partial: event.partial,
        turnComplete: event.turnComplete
    };
}
//# sourceMappingURL=sessions.events.legacy.js.map